export default "__VITE_ASSET__WH5p0z5F__"